import Hashids from "hashids";

const SALT = "exclusive-lounge-event-2024";
const MIN_LENGTH = 10;

const hashids = new Hashids(SALT, MIN_LENGTH);

const LANGUAGE_MAP: Record<string, number> = { pt: 0, en: 1, es: 2 };
const INDEX_TO_LANGUAGE: Record<number, string> = { 0: "pt", 1: "en", 2: "es" };

function stringToHex(str: string): string {
  return Array.from(str)
    .map((c) => c.charCodeAt(0).toString(16).padStart(2, "0"))
    .join("");
}

function hexToString(hex: string): string {
  const pairs = hex.match(/.{2}/g) || [];
  return pairs.map((h) => String.fromCharCode(parseInt(h, 16))).join("");
}

export function encodeId(id: string): string {
  return hashids.encodeHex(stringToHex(id));
}

export function decodeId(hash: string): string | null {
  const hex = hashids.decodeHex(hash);
  if (!hex) return null;
  return hexToString(hex);
}

export function encodeEventData(
  externalId: string,
  tenantExternalId: string,
  language: string
): string {
  const userId = parseInt(externalId, 10);
  const tenantId = parseInt(tenantExternalId, 10);
  const langIndex = LANGUAGE_MAP[language] ?? 0;
  return hashids.encode(userId, tenantId, langIndex);
}

export function decodeEventData(
  hash: string
): { externalId: string; tenantExternalId: string; language: string } | null {
  const decoded = hashids.decode(hash) as number[];
  if (decoded.length !== 3) return null;
  const [userId, tenantId, langIndex] = decoded;
  return {
    externalId: String(userId),
    tenantExternalId: String(tenantId),
    language: INDEX_TO_LANGUAGE[langIndex] ?? "pt",
  };
}
